/* CheckmarkRenderer.js */

"use strict";

//const _ = require("lodash");

class CheckmarkRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("Checkmark-column");
        this._rootElem.component = this._model;
        this._rootElem.classList.add(this._model._sevLvl);
        this._registerListeners();
        this.render();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
        return prom;
    }
    _registerListeners() {
        this._model.on("Checkmark", (this._onCheckmark = this._onCheckmark.bind(this)));
    }
    _unregisterListeners() {
        this._model.removeAllListeners("Checkmark");
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._setCheckmark(this._model.getValue());
            resolve();
        });
        return prom;
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onCheckmark(newVal) {
        this._setCheckmark(newVal);
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    _setCheckmark(newVal) {
        if (newVal === 0 || newVal) {
            this._rootElem.innerHTML = newVal === 0 ? "<base-icon-gl data-icon='common.check'></base-icon-gl>" : newVal;
        } else {
            this._rootElem.innerHTML = "-";
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = CheckmarkRenderer;
